<template>
  <div class="pesanan-sukses">
    <Navbar/>
    <div class="container">
        <div class="row justify-content-center mt-5">
            <div class="col text-center" style="margin-top:100px;">
                <img src="../assets/img/eat.svg" class="img-fluid mb-5" width="300">
                <h2 v-if="saveError"><strong>Pembayaran berhasil</strong></h2>
                <h2 v-else><strong>Sukses !!</strong></h2>
                <h4 v-if="submitting">Menyimpan pesanan...</h4>
                <h4 v-else-if="saveError">Pesanan belum tercatat. {{ saveError }}</h4>
                <h4 v-else>Pesanan segera di proses</h4>
                <button
                  v-if="saveError && !submitting"
                  type="button"
                  class="btn btn-success mt-3"
                  @click="retrySubmit"
                >
                  Kirim ulang pesanan
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import { formatPesananError, getKeranjang, getMidtransOrderId, submitPesanan } from "@/utils/pesanan";

export default {
  name: "PesananSukses",
  components: {
    Navbar,
  },
  data() {
    return {
      submitting: false,
      saveError: "",
    };
  },
  methods: {
    async retrySubmit() {
      await this.submitIfNeeded();
    },
    async submitIfNeeded() {
      const alreadySaved = this.$route.query.saved === "1";
      const keranjangs = getKeranjang();
      const paymentMethod = localStorage.getItem("midtrans_payment_method") || "qris";

      if (alreadySaved || localStorage.getItem("midtrans_order_saved") === "1") {
        this.saveError = "";
        return;
      }
      if (keranjangs.length === 0 && !getMidtransOrderId()) {
        if (this.$route.query.saved === "0" && !this.saveError) {
          this.saveError = "Gagal menyimpan pesanan ke server. Coba kirim ulang.";
        }
        return;
      }

      this.submitting = true;
      this.saveError = "";
      try {
        await submitPesanan({ method: paymentMethod });
        this.$toast.success("Pesanan berhasil dicatat", {
          position: "top-right",
          type: "success",
          duration: 3000,
          dismissible: true,
        });
      } catch (err) {
        this.saveError = formatPesananError(err);
        this.$toast.error(this.saveError, {
          position: "top-right",
          type: "error",
          duration: 8000,
          dismissible: true,
        });
      } finally {
        this.submitting = false;
      }
    },
  },
  async mounted() {
    if (this.$route.query.saved === "0") {
      this.saveError = "Gagal menyimpan pesanan ke server. Coba kirim ulang.";
    }
    await this.submitIfNeeded();
  },
};
</script>

<style>
</style>
